import { Card, CardBody, DatePicker } from '@heroui/react';
import { parseDate } from '@internationalized/date';
import dayjs from 'dayjs';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export function DateInput({ sendAnswer, answerHistory }) {
  const { t } = useTranslation();

  const [error, setError] = useState(false);

  const validateDate = (date) => {
    let result = false;
    result = dayjs(date, 'YYYY-MM-DD', true).isValid();
    return result;
  };

  const handleInputChange = (date) => {
    setError(false);
    if (!date) return;

    const dateString = dayjs(date.toString()).format('YYYY-MM-DD').toString();
    const valid = validateDate(dateString);

    if (!valid) {
      setError(true);
      return;
    }

    sendAnswer(dateString);
  };

  return (
    <Card className="max-w-md">
      <CardBody>
        <DatePicker
          color="primary"
          defaultValue={answerHistory ? parseDate(answerHistory) : null}
          label={t('common.input.date')}
          onChange={(date) => handleInputChange(date)}
          error={error}
          errorMessage={t('common.error.invalid_date')}
          showMonthAndYearPickers
          variant="underlined"
        />
      </CardBody>
    </Card>
  );
}
